import React from 'react';
import { useAppSelector, useAppDispatch } from '../../store/hooks';
import {
    selectSearchFilters,
    selectSearchOptions,
    setSearchFilters,
} from '../../store/slices/datagridSlice';
import FilterEditField from './filterEditField';
import { dataGridGenerateQLString } from '../../utilities/datagrid';

const FilterSelectCard = () => {
    const dispatch = useAppDispatch();
    const filters = useAppSelector(selectSearchFilters);
    const searchOptions = useAppSelector(selectSearchOptions);

    const handleFilterChange = (updatedFilter) => {
        const updatedFilters = structuredClone(filters);
        const f = updatedFilters.find((filter) => filter.id === updatedFilter.id);
        if (f) {
            f.fieldName = updatedFilter.fieldName;
            f.operator = updatedFilter.operator;
            f.value = updatedFilter.value;
        } else {
            updatedFilters.push({ ...updatedFilter });
        }
        dispatch(setSearchFilters(updatedFilters));
    };

    const handleFilterRemove = (id) => {
        const index = filters.findIndex((f) => f.id === id);
        if (index >= 0) {
            const newFilters = [...filters];
            newFilters.splice(index, 1);
            dispatch(setSearchFilters(newFilters));
        }
    };

    const renderFiltersQueryString = () => {
        const qlString = dataGridGenerateQLString(filters, searchOptions);
        return qlString.length ? (
            <span>Filters: {qlString}</span>
        ) : (
            <span>No Filters Set</span>
        );
    };

    return (
        <>
            {filters.length ? (
                filters.map((f, i) => (
                    <React.Fragment key={f.id}>
                        <FilterEditField
                            onFieldChange={handleFilterChange}
                            onRemove={handleFilterRemove}
                            values={f}
                        />
                        {i === filters.length - 1 && (
                            <FilterEditField
                                onFieldChange={handleFilterChange}
                                onRemove={handleFilterRemove}
                            />
                        )}
                    </React.Fragment>
                ))
            ) : (
                <FilterEditField
                    onFieldChange={handleFilterChange}
                    onRemove={handleFilterRemove}
                />
            )}
            <div className="mt-2" style={{ fontSize: '12px' }}>
                {renderFiltersQueryString()}
            </div>
        </>
    );
};

export default FilterSelectCard;
